import React from 'react';
import { FiArrowRight, FiCheckCircle, FiShield, FiTrendingUp } from 'react-icons/fi';
import ContactForm from './ContactForm';

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#F4FBF8]">
      <div className="absolute inset-x-0 top-0 h-[430px] bg-[#E9F6F0]" />

      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mx-auto max-w-5xl text-center">
          <div className="mx-auto mb-6 h-1.5 w-24 rounded-full bg-[#D97706]" />
          <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-[#0B2F2A] sm:text-5xl lg:text-6xl">
            Get Support for Your Subscription, Billing, or Account Questions
          </h1>

          <p className="mx-auto mt-6 max-w-3xl text-lg font-normal leading-8 text-[#1E3A33]">
            Our operators are trained by our partners to answer all your questions quickly and efficiently.
          </p>
          <p className="mx-auto mt-4 max-w-3xl text-lg font-normal leading-8 text-[#1E3A33]">
            The subscription services that we provide offer our customers a unique solution to multiple problems.
          </p>
          <div className="mx-auto mt-8 h-[3px] w-full max-w-5xl bg-gradient-to-r from-[#D97706] via-[#14B8A6] to-[#166534]" />
        </div>

        <div className="mt-12 grid overflow-hidden rounded-2xl border border-emerald-900/10 bg-white shadow-2xl shadow-emerald-950/10 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="p-4 sm:p-6 lg:p-8">
            <ContactForm />
          </div>

          <div className="border-t border-emerald-900/10 bg-[#0B2F2A] p-8 text-white lg:border-l lg:border-t-0 lg:p-10">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-[#FCD34D]">
              Contact us
              <FiArrowRight className="h-4 w-4" />
            </div>
            <p className="mt-5 text-sm leading-7 text-emerald-100/90">
              Support for subscription management, cancellation, and partner-site questions.
            </p>

            <div className="mt-8 space-y-5">
              <div className="border-l-2 border-[#FCD34D] pl-4">
                <div className="flex items-center gap-2 text-sm font-bold text-white">
                  <FiCheckCircle className="h-4 w-4 text-[#FCD34D]" />
                  Simplified support
                </div>
                <p className="mt-2 text-sm leading-6 text-emerald-100/90">Reach your customer account in one click and manage your subscription information.</p>
              </div>
              <div className="border-l-2 border-[#FCD34D] pl-4">
                <div className="flex items-center gap-2 text-sm font-bold text-white">
                  <FiShield className="h-4 w-4 text-[#FCD34D]" />
                  Recognized expertise
                </div>
                <p className="mt-2 text-sm leading-6 text-emerald-100/90">We provide the after-sales service of several partner sites and support every single client.</p>
              </div>
              <div className="border-l-2 border-[#FCD34D] pl-4">
                <div className="flex items-center gap-2 text-sm font-bold text-white">
                  <FiTrendingUp className="h-4 w-4 text-[#FCD34D]" />
                  Agents at your service
                </div>
                <p className="mt-2 text-sm leading-6 text-emerald-100/90">Our agents are experts in after-sales services and answer your questions quickly.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
